import axios from '../shared/axios';
// import qs from 'querystring';
import store from "../store/store";
import * as contractDuck from "../store/ducks/contract.duck";
import * as events from './events';
import SystemHelper from "../shared/systemHelper";

export function saveInspectionDefect(data) {
    return new Promise((resolve, reject) => {
        axios.post(`/api/InspectionDefect/SaveInspectionDefect`, data)
            .then(result => {
                events.onNotification_CREATED();
                resolve(result);
            })
            .catch(error => reject(error));
    });
}
export function updateInspectionDefect(data) {
    return new Promise((resolve, reject) => {
        axios.post(`/api/InspectionDefect/Update`, data)
            .then(result => {
                switch (data.actioncode) {
                    case 'SAVE_DRAFT':
                        events.onNotification_DRAFT_SAVED();
                        break;
                    case 'COMMUNICATE':
                        events.onNotification_COMMUNICATED();
                        break;
                    case 'REPLY_DRAFT':
                        events.onNotification_REPLY_DRAFT_SAVED();
                        break;
                    case 'REPLY_SEND':
                        events.onNotification_REPLY_SENT();
                        break;
                    default:
                        alert('Unknown action code!');
                        break;
                }
                store.dispatch({ type: contractDuck.actionTypes.CONTRACT_REFRESH_DASHBOARD });
                resolve(result);
            })
            .catch(error => reject(error));
    });
}
export function updateInspectionDefectAction(data) {
    return new Promise((resolve, reject) => {
        axios.post(`/api/InspectionDefect/UpdateDefectAction`, data)
            .then(result => {
                store.dispatch({ type: contractDuck.actionTypes.CONTRACT_REFRESH_DASHBOARD });
                resolve(result);
            })
            .catch(error => reject(error));
    });
}
export function updateConformanceAction(data) {
    return new Promise((resolve, reject) => {
        axios.post(`/api/InspectionDefect/UpdateConformanceAction`, data)
            .then(result => {
                store.dispatch({ type: contractDuck.actionTypes.CONTRACT_REFRESH_DASHBOARD });
                resolve(result);
            })
            .catch(error => reject(error));
    });
}
export function closeInspectionDefect(data) {
    return new Promise((resolve, reject) => {
        axios.post(`/api/InspectionDefect/CloseDefect`, data)
            .then(result => {
                store.dispatch({ type: contractDuck.actionTypes.CONTRACT_REFRESH_DASHBOARD });
                resolve(result);
            })
            .catch(error => reject(error));
    });
}
export function updateInspectionDefectPlannedClosure(data) {
    return new Promise((resolve, reject) => {
        axios.post(`/api/InspectionDefect/PlannedClosureUpdate`, data)
            .then(result => {
                store.dispatch({ type: contractDuck.actionTypes.CONTRACT_REFRESH_DASHBOARD });
                resolve(result);
            })
            .catch(error => reject(error));
    });
}
export function getInspectionDefect(earlyinspectiondefectid) {
    return axios.get(`/api/InspectionDefect/GetInspectionDefectV2?earlyinspectiondefectid=${earlyinspectiondefectid}`);
}
// export function getContractNotifications(companyid, projectid, contractid) {
//     return axios.post(`/api/InspectionDefect/LoadInspectionDefectsList?companyid=${companyid}&projectid=${projectid}&contractid=${contractid}&type=Notification`);
// }

// export function getContractRfi(companyid, projectid, contractid) {
//     return axios.post(`/api/InspectionDefect/LoadInspectionDefectsList?companyid=${companyid}&projectid=${projectid}&contractid=${contractid}&type=RFI`);
// }
export function getContractInspections(companyid, projectid, contractid, type, accessibleWfIds) {
    return axios.post(`/api/InspectionDefect/LoadInspectionDefectsList`, { accessibleWfIds }, { params: { companyid, projectid, contractid, type } });
}
export function getInspectionsReduced(companyid, projectid, contractid, type, accessibleWfIds) {
    return axios.post(`/api/InspectionDefect/RegisterList`, { accessibleWfIds }, { params: { companyid, projectid, contractid, type } });
}

export function getInspectionsReducedV2(companyid, projectid, contractid, type, showDrafts, accessibleWfIds) {
    return axios.post(`/api/InspectionDefect/RegisterListV2`, {
        showDrafts: showDrafts,
        showRelations: process.env.REACT_APP_COMMUNICATION_REL_ENABLED === 'true',
        showTags: process.env.REACT_APP_COMMUNICATION_TAG_ENABLED === 'true',
        showCustomFields: SystemHelper.getSettingValueBoolean(SystemHelper.SETTINGS.CUSTOM_FIELDS_ENABLED),
        excludeTagHeaders: true,
        accessibleWfIds
    },
        { params: { companyid, projectid, contractid, type } });
}

export function getInsDefToSelectList(contractid, type) {
    return axios.get(`/api/InspectionDefect/ToSelectList`, { params: { contractid, type } });
}

export function deleteInspectionDraft(inspectiondefectid) {
    return new Promise((resolve, reject) => {
        axios.post(`api/InspectionDefect/DeleteDraft?inspectiondefectid=${inspectiondefectid}`)
            .then(result => {
                events.onNotification_DELETED();
                resolve(result);
            })
            .catch(error => reject(error));
    })
}


export function importInspectionDefects(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.post(`/api/InspectionDefect/Import`, data);
            events.onNotification_CREATED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}

export function deleteInspectionDefectDrafts(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.delete(`/api/InspectionDefect/BulkDeleteDraft`, { data: data });
            events.onNotification_DELETED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}

export function communicateInspectionDefectDrafts(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.put(`/api/InspectionDefect/BulkCommunicate`, data);
            events.onNotification_COMMUNICATED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}